export const URLS = {
  accounts: {
    me: 'me/',
    notifications: 'me/notifications/',
    subAccounts: 'sub-accounts/',
  },
  adminDashboardPanel: {
    all: 'admin/safeguard/panels/',
    create: 'admin/safeguard/panels/',
    delete: (panelId: string) => `admin/safeguard/panels/${panelId}/`,
    update: (panelId: string) => `admin/safeguard/panels/${panelId}/`,
  },
  adminSafeGuard: {
    all: 'admin/safeguard/users/',
    create: 'admin/safeguard/users/',
    delete: (userId: string) => `admin/safeguard/users/${userId}/`,
    update: (userId: string) => `admin/safeguard/users/${userId}/`,
  },
  adminUsers: {
    all: 'admin/users/',
    create: 'admin/users/',
    delete: (userId: string) => `admin/users/${userId}/`,
    update: (userId: string) => `admin/users/${userId}/`,
  },
  assets: {
    all: 'assets/',
    create: 'assets/',
    detail: (assetId: string) => `assets/${assetId}/`,
    search: 'search/assets/', // By core API
    dataSearch: 'assets/search/',
    types: 'asset-types/',
    update: (assetId: string) => `assets/${assetId}/`,
  },
  bulkFiles: {
    all: 'csv-files/',
    create: (bulkFileId: string) => `csv-files/${bulkFileId}/`,
    delete: (bulkFileId: string) => `csv-files/${bulkFileId}/`,
    detail: (bulkFileId: string) => `csv-files/${bulkFileId}/`,
  },
  clients: {
    all: 'clients/',
    create: 'clients/',
    detail: (clientId: string) => `clients/${clientId}/`,
    update: (clientId: string) => `clients/${clientId}/`,
    search: 'search/clients/',
  },
  commands: {
    // By core API
    all: 'commands/admin/available/',
    historic: 'commands/admin/',
    reports: 'commands/admin/reports/',
    downloadReport: (reportId: string) => `commands/admin/reports/${reportId}/`,
    availableByDeviceModel: (deviceModelId: string) => `commands/device-model/${deviceModelId}/`,
    availables: (assetId: string) => `commands/asset/${assetId}/`,
    send: (assetId: string) => `commands/asset/${assetId}/`,
  },
  devices: {
    // By configuration
    brandList: 'devices/brands/',
    createBrand: 'devices/brands/',
    createModel: 'devices/models/',
    modelList: 'devices/models/',
    // End by configuration
    all: 'devices/',
    create: 'devices/',
    carrierList: 'devices-carriers/',
    detail: (deviceId: string) => `devices/${deviceId}/`,
    update: (deviceId: string) => `devices/${deviceId}/`,
  },
  installations: {
    all: 'emissions/assignments/',
    campaignsList: 'emissions/assignments/campaigns/',
    create: 'emissions/assignments/',
    detail: (installationId: string) => `emissions/assignments/${installationId}/`,
    logsList: (installationId: string) => `emissions/assignments/${installationId}/logs/`,
    newLog: (installationId: string) => `emissions/assignments/${installationId}/log/`,
    statusList: 'emissions/assignments/status/',
    phoneStatus: (installationId: string) => `emissions/assignments/${installationId}/phone/status/`,
    phoneTags: 'emissions/assignments/phone/tags/',
    update: (installationId: string) => `emissions/assignments/${installationId}/`,
    updateStatus: (installationId: string) => `emissions/assignments/${installationId}/status/`,
  },
  jobs: {
    create: (installationId: string) => `emissions/assignments/${installationId}/schedule/`,
    workers: (installationId: string) => `emissions/assignments/${installationId}/schedule/`,
  },
  logs: {
    emissionsTypes: 'emissions/assignments/logs-types/',
    webServiceDetail: (webServiceLogId: string) => `external-ws/logs/${webServiceLogId}/`,
    webServiceList: 'external-ws/logs/',
  },
  massiveCommands: {
    all: 'commands/massive/',
    create: 'commands/massive/',
    detail: (commandId: string) => `commands/massive/${commandId}/`,
  },
  permissions: {
    all: 'catalogs/app-permissions/', // From configuration
  },
  phonesBl: {
    addRemove: 'emissions/assignments/blacklist/',
    all: 'emissions/assignments/blacklist/',
  },
  reports: {
    devices: 'reports/reporting-devices/',
    devicesOffline: 'reports/reporting-devices/offline/',
    deviceFileUrl: (reportId: string) => `reports/reporting-devices/offline/${reportId}/`,
    downloadEmissions: (reportId: string) => `emissions/assignments/reports/${reportId}/`,
    emissions: 'emissions/assignments/reports/',
  },
  subAccounts: {
    all: 'sub-accounts/',
    create: 'sub-accounts/',
    detail: (subAccountId: string) => `sub-accounts/${subAccountId}/`,
    update: (subAccountId: string) => `sub-accounts/${subAccountId}/`,
  },
  subClients: {
    all: 'sub-clients/',
    create: 'sub-clients/',
    detail: (subClientId: string) => `sub-clients/${subClientId}/`,
    update: (subClientId: string) => `sub-clients/${subClientId}/`,
    search: 'search/sub-clients/',
    configuration: {
      update: (subClientId: string) => `sub-clients/${subClientId}/configuration/`,
    },
  },
  users: {
    all: 'users/',
    changePassword: (userId: string) => `users/${userId}/password/`,
    create: 'users/',
    detail: (userId: string) => `users/${userId}/`,
    update: (userId: string) => `users/${userId}/`,
  },
  vehicles: {
    // By configuration
    createBrand: 'vehicles/brands/',
    createSubBrand: 'vehicles/sub-brands/',
    brandList: 'vehicles/brands/',
    subBrandList: 'vehicles/sub-brands/',
    // End by configuration
    createVersion: 'vehicles-versions/',
    updateVersion: (versionId: string) => `vehicles-versions/${versionId}/`,
    versionList: 'vehicles-versions/',
  },
  webHooks: {
    all: (clientId: string) => `clients/${clientId}/webhooks/`,
    create: (clientId: string) => `clients/${clientId}/webhooks/`,
    delete: (clientId: string, webhookId: string) => `clients/${clientId}/webhooks/${webhookId}/`,
    updateStatus: (clientId: string, webhookId: string) => `clients/${clientId}/webhooks/${webhookId}/active/`,
  },
  webService: {
    all: 'external-ws/',
    create: 'external-ws/',
    detail: (webServiceId: string) => `external-ws/${webServiceId}/`,
    update: (webServiceId: string) => `external-ws/${webServiceId}/`,
  },
  whatsapp: {
    all: 'whatsapp/campaigns/',
    create: 'whatsapp/campaigns/',
    detail: (whatsappId: string) => `whatsapp/campaigns/${whatsappId}/`,
    templates: 'whatsapp/templates/',
  },
  safeGpt: {
    all: 'safegpt/alarms/configuration/',
    create: 'safegpt/alarms/configuration/',
    update: (safeGptId: string) => `safegpt/alarms/configuration/${safeGptId}/`,
    alarmTypes: 'safegpt/alarms/',
    audioReactions: 'safegpt/alarms/audio-reactions/',
  },
  fleetHealth: {
    rules: {
      all: 'health/configuration/',
      create: 'health/configuration/',
      update: (ruleId: string) => `health/configuration/${ruleId}/`,
    },
    alarms: {
      types: {
        all: 'notification/types/', // CORE
      },
    },
    events: {
      all: 'health/events/',
      detail: (eventId: string) => `health/events/${eventId}/`,
      status: {
        all: 'health/events/status/',
        update: (eventId: string) => `health/events/${eventId}/status/`,
      },
      timeline: {
        all: (eventId: string) => `health/events/${eventId}/timeline/`,
      },
      logs: {
        all: (eventId: string) => `health/events/${eventId}/logs/`,
        update: (eventId: string) => `health/events/${eventId}/logs/`,
      },
    },
  },
  deviceModels: {
    search: 'search/devices-models/',
  },
  maintenances: {
    types: {
      all: 'maintenances/types/',
      create: 'maintenances/types/',
      update: (maintenanceTypeId: string) => `maintenances/types/${maintenanceTypeId}/`,
    },
    configurations: {
      all: 'maintenances/configurations/',
      create: 'maintenances/configurations/',
      update: (configurationId: string) => `maintenances/configurations/${configurationId}/`,
    },
  },
  notification: {
    types: {
      all: 'notification/types/', // CORE
    },
  },
  catalogs: {
    permissions: {
      create: 'app-permissions/elements/',
      delete: 'app-permissions/elements/remove/',
      update: 'app-permissions/elements/edit/',
    },
    alarms: {
      all: 'safegpt/alarms/catalog/',
      create: 'safegpt/alarms/catalog/',
      update: (alarmConfigId: string) => `safegpt/alarms/catalog/${alarmConfigId}/`,
      delete: (alarmConfigId: string) => `safegpt/alarms/catalog/${alarmConfigId}/`,
    },
    notifications: {
      all: 'notification/types/catalog/',
      create: 'notification/types/catalog/',
      update: (notificationConfigId: string) => `notification/types/catalog/${notificationConfigId}/`,
      delete: (notificationConfigId: string) => `notification/types/catalog/${notificationConfigId}/`,
    },
  },
};
